module.exports = __webpack_public_path__ + "static/media/hotel-white.91de5c02.svg";